import { axiosInstance, API_PREFIX, type ApiResponse } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import type {
  CourierTaskBase,
  CourierTaskDetail,
  CourierTaskListParams,
  CourierTaskPaymentAcceptPayload,
  CourierTaskReturnAcceptPayload,
} from '../model/types';

const BASE = `${API_PREFIX.ADMIN_V1}/courier-task`;

export const getList = async (params?: CourierTaskListParams): Promise<ApiResponseList<CourierTaskBase>> => {
  const { data } = await axiosInstance.get<ApiResponseList<CourierTaskBase>>(`${BASE}/index`, { params });
  return data;
};

export const getById = async (id: number, type: number): Promise<ApiResponse<CourierTaskDetail>> => {
  const { data } = await axiosInstance.get<ApiResponse<CourierTaskDetail>>(`${BASE}/show`, {
    params: { id, type },
  });
  return data;
};

export const paymentAccept = async (payload: CourierTaskPaymentAcceptPayload): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${BASE}/payment-accept`, payload);
  return data;
};

export const returnAccept = async (payload: CourierTaskReturnAcceptPayload): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${BASE}/return-accept`, payload);
  return data;
};
